import React, { useEffect, useRef, useState } from "react";
import Localization from "../../../../../localization";
import { Images } from "../../../../../assets";
import { AjaxApi } from "../../../../../apis";
import { useApi } from "../../../../../hooks";
import { Flex } from "antd";
import {
  ContentLoader,
  Button,
  Modal,
  Form,
  Text,
  List,
} from "../../../../../components";

const Hubs = ({ selectedHub = "", onClick = () => {} }) => {
  const [loading, setLoading] = useState(false);
  const [hubs, setHubs] = useState([]);
  const { execute } = useApi();

  useEffect(() => {
    getHubs();
  }, []);

  const getHubs = async () => {
    const hubs = await execute(() => AjaxApi.hubs(), { setLoading });
    setHubs(hubs);
  };

  if (loading)
    return (
      <ContentLoader
        skeletons={[{ size: "small" }, { size: "large", height: 70 * 3 }]}
      />
    );
  return (
    <div>
      <Text
        level={5}
        weight={700}
        type="secondary"
        className="m-15-b"
        children={Localization.service.edit_alarm_connection_hubs_desc}
      />
      <List
        dataSource={hubs}
        itemLayout="horizontal"
        renderItem={({ name, hubId }) => {
          const isConnected = hubId === selectedHub;
          return (
            <List.Item
              disabled={isConnected}
              onClick={() => onClick(hubId)}
              children={
                <List.Item.Meta
                  title={name}
                  description={hubId}
                  avatar={
                    <img style={{ height: "3.7rem" }} src={Images.ajaxHub} />
                  }
                />
              }
              extra={
                isConnected && (
                  <Text
                    weight={"600"}
                    color="secondary"
                    className="m-10-l"
                    children={Localization.general.connected}
                  />
                )
              }
            />
          );
        }}
      />
    </div>
  );
};

const Ajax = ({ alarmModel, onDone = async () => {} }) => {
  const [loading, setLoading] = useState(false);
  const [ajaxUser, setAjaxUser] = useState({});
  const ajaxLoginModalRef = useRef();
  const hubsModalRef = useRef();
  const ajaxLoginForm = useRef();
  const { execute } = useApi();

  const identifier = alarmModel?.uuid === 120 && alarmModel?.identifier;

  useEffect(() => {
    getUser();
  }, []);

  const getUser = async () => {
    const user = await execute(() => AjaxApi.user(), { setLoading });
    setAjaxUser(user);
  };

  const renderAjaxLogin = () => {
    return (
      <div>
        <Text
          level={5}
          weight={700}
          type="secondary"
          className="m-15-b"
          children={Localization.service.edit_alarm_connection_login_desc}
        />
        <Form
          ref={ajaxLoginForm}
          fields={[
            {
              type: "email",
              name: "email",
              placeholder: "name@example.com",
              label: Localization.general.email_address,
              rules: [{ type: "email", required: true }],
            },
            {
              type: "password",
              name: "password",
              label: Localization.general.password,
              placeholder: Localization.general.type_password,
              rules: [{ min: 4, required: true }],
            },
          ]}
        />
        <Form.Submit
          type="primary"
          className="m-30-t"
          title={Localization.general.login}
          onClick={async () => {
            try {
              await ajaxLoginForm.current.validateFields();
              await execute(async () =>
                AjaxApi.login(ajaxLoginForm.current.getFieldsValue())
              );
              await getUser();
              ajaxLoginModalRef.current.close();
            } catch (error) {}
          }}
        />
      </div>
    );
  };

  if (loading)
    return (
      <ContentLoader
        skeletons={[
          { size: "large", height: 70 },
          { size: "small" },
          { size: "large", height: 70 },
        ]}
      />
    );
  if (!ajaxUser?.login) return renderAjaxLogin();
  return (
    <div>
      <Text
        level={5}
        weight={700}
        type="secondary"
        children={Localization.general.ajax_account}
      />
      <Text type="secondary" className="m-5-t" children={ajaxUser?.login} />
      <Button
        className="m-15-t"
        type="primary"
        title={Localization.general.change_account}
        onClick={() => ajaxLoginModalRef.current.open()}
      />
      <Flex gap={"1rem"} className="m-30-t">
        <img
          style={{ height: "4.3rem" }}
          src="https://testapp.safe.land/img/connect/ajax-hub.png"
        />
        <div>
          <Text
            level={5}
            weight={700}
            type="secondary"
            children={Localization.general.ajax_hubId}
          />
          <Text
            type="secondary"
            className="m-5-t"
            children={
              !identifier ? Localization.general.not_connected : identifier
            }
          />
        </div>
      </Flex>
      <Button
        type="primary"
        className="m-15-t"
        onClick={() => hubsModalRef.current.open()}
        title={
          !identifier
            ? Localization.general.select_hub
            : Localization.general.change_hub
        }
      />
      <Modal
        ref={hubsModalRef}
        title={Localization.service.edit_alarm_connection_modal_title}
        child={() => <Hubs selectedHub={identifier} onClick={onDone} />}
      />
      <Modal
        ref={ajaxLoginModalRef}
        child={renderAjaxLogin}
        title={Localization.service.edit_alarm_connection_modal_title}
      />
    </div>
  );
};

export default Ajax;
